import { create } from "zustand";

export const useMergeContactModalStore = create((set) => ({
  mergedContactDetailsForm: {
    name: "",
    emailId: "",
    phoneNumber: "",
    instaUsername: "",
  },
  selectedRecords: {},
  openMergeSelectionModal: false,
  openFormModal: false,
  openConfirmationModal: false,
  setOpenMergeSelectionModal: (val) => set({ openMergeSelectionModal: val }),
  setOpenFormModal: (val) => set({ openFormModal: val }),
  setOpenConfirmationModal: (val) => set({ openConfirmationModal: val }),
  setSelectedRecords: (val) => set({ selectedRecords: val }),
  setMergedContactDetails: (key, val) =>
    set((state) => ({
      mergedContactDetailsForm: {
        ...state.mergedContactDetailsForm,
        [key]: val,
      },
    })),
  initialiseMergedContactDetails: (val) =>
    set({ mergedContactDetailsForm: val }),
  resetMergedContactDetails: () =>
    set({
      mergedContactDetailsForm: {
        name: "",
        emailId: "",
        phoneNumber: "",
        instaUsername: "",
      },
    }),
}));
